import React, { useEffect, useState } from "react";
import {
  lead_status,
  old_lead_status,
  new_lead_status,
} from "../../Config/leadStatus";
import { ehcExpert } from "../../Config/ehcExpert";
import AssessmentDataService from "../../services/Assessment";
import {
  AllStates,
  Budget,
  EducationalQualifications,
  FitnessOptions,
  GenderOptions,
  Issues,
  LengthOfConcern,
  OccupationType,
  PreferedLanguage,
  RelationshipStatus,
  SuggestedExperts,
  SuggestedTherapyType,
  TherapistAgeGroup,
  TheraputicHistory,
  TherapyDeliveryMode,
  UrgencyOfIntervention,
  YesNoOptions,
} from "../../Config/AddAssessmentOptions";
import { MultiSelect } from "react-multi-select-component";
import { assessmentData } from "../../Config/AsessmentData";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import { DateTime } from "luxon";
import Select from "react-select";
import NotificationService from "../../services/Notification";

export const AddAssessment = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const user = localStorage.getItem("logged_in_User");
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const loginUserId = localStorage.getItem("logged_in_user_id") || "" || "";
  const ehcPage = localStorage.getItem("ehc_page");
  const leadStatusOptions =
    ehcPage === "old" ? old_lead_status : new_lead_status;

  const toast = useToast();
  const navigate = useNavigate();
  const [therapyMode, setTherapyMode] = useState<any>("");
  const [therapyType, setTherapytype] = useState<any>("");
  const [isNameError, setIsNameError] = useState(false);
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isStatusError, setIsStatusError] = useState(false);
  const [bookingDetails, setBookingDetails] = useState<any>({
    booking_date: "",
    booking_time: "",
    booking_expert: "",
    subscription_amount: "",
    booking_amount: "",
  });
  const [assessment, setAssessment] = useState<any>(assessmentData);
  const [theraputicHistory, setTheraputicHistory] = useState<any>("");
  const [selected, setSelected] = useState<any>([]);
  const [isNotificationSend, setIsNotificationSend] = useState<any>(false);
  const [language, setLanguage] = useState<any>([]);
  const handleBookingDetails = (e: any) => {
    setBookingDetails({ ...bookingDetails, [e.target.name]: e.target.value });
  };
  const handleTheraputicHistory = (e: any) => {
    setTheraputicHistory(e.target.value);
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setAssessment((prev: any) => ({
      ...prev,
      ...(accessControls.includes("juniorEhcExpert") && {
        expert: `expert_${loginUserId}`,
      }),
      [name]: value,
    }));
  };
  const handleDataChange = () => {
    let dateTime: any = "";

    if (assessment.date && assessment.time) {
      const dt = DateTime.fromFormat(
        `${assessment.date} ${assessment.time}`,
        "yyyy-LL-dd HH:mm",
        { zone: "Asia/Kolkata" } 
      );

      dateTime = dt.toUTC().toJSDate();
      // const isoString = `${assessment.date}T${assessment.time}:00Z`;
      // dateTime = new Date(isoString);
    }

    // console.log(dateTime);
    setAssessment({
      ...assessment,
      date_time: dateTime,
      lead_expert:
        user === "expert" ? "Rachel" : user === "marketing" ? "Abdul" : "",
      booking_entry: bookingDetails.booking_date != "" ? [bookingDetails] : [],
      types_of_theraputic_history:
        theraputicHistory != "" ? [theraputicHistory] : [],
      therapy_type: therapyType != "" ? [therapyType] : [],
      therapy_delivery_modes: therapyMode != "" ? [therapyMode] : [],
      languages: language.map((el: any) => el.value),
      issues: selected.map((el: any) => el.value),
    });
  };
  const handleCheckboxChange = () => {
    let dateTime = DateTime.now().setZone("Asia/Kolkata");
    const data = {
      template_name: "ehc_notification",
      lead_phone_numbers: ["+917607471747", "+919643067955", "+919554840740"],
      notification_status: "PENDING",
      variable_values: [
        DateTime.fromFormat(assessment.date, "yyyy-LL-dd").toFormat(
          "dd MMM yy"
        ),
        DateTime.fromFormat(assessment.time, "HH:mm").toFormat("hh:mm a"),
      ],
      error: [],
      source: "SERVICE",
      schedule_date: dateTime.toFormat("MM/dd/yyyy"),
      schedule_time: dateTime.toFormat("h:mm a"),
      booking_id: "",
    };
    NotificationService.scheduleWhatsappNotification(data);
  };
  const handleSubmit = () => {
    if (
      assessment.name === "" ||
      assessment.phone === "" ||
      assessment.email === "" ||
      assessment.new_lead_status === ""
    ) {
      assessment.name === "" ? setIsNameError(true) : setIsNameError(false);
      assessment.phone === "" ? setIsPhoneError(true) : setIsPhoneError(false);
      assessment.email === "" ? setIsEmailError(true) : setIsEmailError(false);
      assessment.new_lead_status === ""
        ? setIsStatusError(true)
        : setIsStatusError(false);
      toast({
        position: "top",
        title: "Registration Failed.",
        description: "You missed required feild.",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    } else {
      setIsNameError(false);
      setIsPhoneError(false);
      setIsEmailError(false);
      setIsStatusError(false);
      AssessmentDataService.create(assessment, token)
        .then((response: any) => {
          if (isNotificationSend) {
            handleCheckboxChange();
          }
          navigate("/freeconsultation");
        })
        .catch((e: any) => {
          if (e.response.status === 401) {
            toast({
              position: "top",
              title: "Authentication Failed.",
              description: "Your session is expired.",
              status: "error",
              duration: 500,
              isClosable: true,
            });
            navigate("/login");
          }
          console.log(e);
        });
    }
  };
  useEffect(() => {
    handleDataChange();
  }, [
    bookingDetails,
    language,
    selected,
    theraputicHistory,
    therapyMode,
    therapyType,
    assessment.date,
    assessment.time,
  ]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Free Consultation</div>
      <div className=" p-5">
        {/* top section */}
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h4 className="mb-3">EHC Information</h4>
            <form className="add_assesment_form">
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_date">
                    Date
                  </label>
                  <input
                    onChange={handleChange}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    name="date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Time (24H Format)
                  </label>
                  <input
                    onChange={handleChange}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    name="time"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Lead Status*
                  </label>
                  <select
                    className="form-control"
                    name="new_lead_status"
                    onChange={handleChange}
                  >
                    {leadStatusOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                  {isStatusError && (
                    <span className="danger">Feild is required</span>
                  )}
                </div>

                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Lead Origin
                  </label>
                  <select
                    defaultValue={"EHC"}
                    className="form-control"
                    name="lead_origin"
                    onChange={handleChange}
                  >
                    <option value="">Select Lead Origin </option>
                    <option value="EHC">EHC</option>
                    <option value="AESS">AESS</option>
                    <option value="WIX">Wix</option>
                    <option value="DEV_APP">Dev App</option>
                    <option value="APP">App</option>
                    <option value="APP_CALL">App Call</option>
                    <option value="APP_CHAT">App Chat</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>
                {!accessControls.includes("juniorEhcExpert") && (
                  <div className="form-group col-md-4 mb-4">
                    <label className="form-label" htmlFor="expert">
                      Ehc Expert
                    </label>
                    <select
                      className="form-control"
                      id="expert"
                      name="expert"
                      onChange={handleChange}
                    >
                      {ehcExpert
                        .filter((el: any) => el.value !== "test1_manisha")
                        .map((el: any) => (
                          <option value={el.value}>{el.name}</option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Service Booking Date & Time</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Date
                  </label>
                  <input
                    onChange={handleChange}
                    type="date"
                    className="form-control"
                    id="service_booking_date"
                    name="service_booking_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Time (24H Format)
                  </label>
                  <input
                    onChange={handleChange}
                    type="time"
                    className="form-control"
                    id="service_booking_time"
                    name="service_booking_time"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Lead Information</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Name*
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="service_booking_name"
                    name="name"
                  />
                  {isNameError && (
                    <span className="danger">Feild is required</span>
                  )}
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_email">
                    Email*
                  </label>
                  <input
                    onChange={handleChange}
                    type="email"
                    className="form-control"
                    id="service_booking_email"
                    name="email"
                  />
                  {isEmailError && (
                    <span className="danger">Feild is required</span>
                  )}
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_phone">
                    Phone*
                  </label>
                  <input
                    onChange={handleChange}
                    type="phone"
                    className="form-control"
                    id="service_booking_phone"
                    name="phone"
                  />
                  {isPhoneError && (
                    <span className="danger">Feild is required</span>
                  )}
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Age
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="service_booking_name"
                    name="age"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="gender">
                    Gender
                  </label>
                  <select
                    className="form-control"
                    id="gender"
                    name="gender"
                    onChange={handleChange}
                  >
                    {GenderOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="state">
                    State
                  </label>
                  <select
                    className="form-control"
                    name="state"
                    id="state"
                    onChange={handleChange}
                  >
                    {AllStates.map((el: any) => (
                      <option value={el.value}>{el.state}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="city">
                    City
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    onChange={handleChange}
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="budget">
                    Budget
                  </label>
                  <select
                    className="form-control"
                    name="budget"
                    id="budget"
                    onChange={handleChange}
                  >
                    {Budget.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="student">
                    Student
                  </label>
                  <select
                    className="form-control"
                    name="student"
                    id="student"
                    onChange={handleChange}
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label
                    className="form-label"
                    htmlFor="educational_qualification"
                  >
                    Educational Qualification
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="educational_qualification"
                    id="educational_qualification"
                  >
                    {EducationalQualifications.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="relationship_status">
                    Relationship Status
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="relationship_status"
                    id="relationship_status"
                  >
                    {RelationshipStatus.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="dependents">
                    Dependents
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="dependents"
                    id="dependents"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="occupation">
                    Occupation
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="occupation"
                    name="occupation"
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="occupation_type">
                    Occupation Type
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="occupation_type"
                    id="occupation_type"
                  >
                    {OccupationType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="family-health-histroy">
                    Family Mental Health Histroy
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="family-health-histroy"
                    id="family-health-histroy"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Psychological Information</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="issues*">
                    Issues
                  </label>
                  <MultiSelect
                    options={Issues}
                    // className="form-control"
                    labelledBy="Select Issues"
                    value={selected}
                    onChange={setSelected}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="symptoms">
                    Other Symptoms
                  </label>
                  <input
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="symptoms"
                    name="symptoms"
                    defaultValue=""
                  />
                </div>
                <div className="col-md-4 mb-4 form-group">
                  <label className="form-label" htmlFor="length_of_concern">
                    Length Of Concern
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="length_of_concern"
                    id="length_of_concern"
                  >
                    {LengthOfConcern.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="frequency_of_symptoms">
                    Frequency Of Symptoms
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="frequency_of_symptoms"
                    id="frequency_of_symptoms"
                  >
                    <option value="">Select If Applicable</option>
                    <option value="sometimes">Sometimes</option>
                    <option value="often">Often</option>
                    <option value="always">Always</option>
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label
                    className="form-label"
                    htmlFor="therapeutic_edication_istory"
                  >
                    Therapeutic Medication History
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="medication_history"
                    id="therapeutic_edication_istory"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="therapeutic_histroy">
                    Therapeutic Histroy
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="therapeutic_histroy"
                    id="therapeutic_histroy"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="types-of-theraputic-history"
                  >
                    Types of Theraputic History
                  </label>
                  <select
                    onChange={handleTheraputicHistory}
                    className="form-control"
                    name="types_of_theraputic_history"
                    id="types-of-theraputic-history"
                  >
                    {TheraputicHistory.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="urgency_of_intervention"
                  >
                    Urgency of Intervention
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="urgency_of_intervention"
                    id="urgency_of_intervention"
                  >
                    {UrgencyOfIntervention.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="current_physical_fitness"
                  >
                    Current Physical Fitness
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="current_physical_fitness"
                    id="Current_physical_health"
                  >
                    {FitnessOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="physical_pain">
                    Physical Pain
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="physical_pain"
                    id="physical_pain"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group  col-md-6 mb-4">
                  <label className="form-label" htmlFor="suggest_therapy_type">
                    Reason Of Interest
                  </label>
                  <textarea
                    onChange={handleChange}
                    className="form-control"
                    id="reason_for_interest"
                    name="reason_of_interest"
                    defaultValue={""}
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="suggest_therapy_type">
                    Health Problems
                  </label>
                  <textarea
                    onChange={handleChange}
                    className="form-control"
                    id="Health_problems"
                    name="health_problems"
                    defaultValue={""}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Expert Preferences</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="gender_of_therapist">
                    Gender of Therapist
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="gender_of_therapist"
                    id="gender_of_therapist"
                  >
                    {GenderOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="age_group_of_therapist">
                    Age Group of Therapist
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="age_group_of_therapist"
                    id="age_group_of_therapist"
                  >
                    {TherapistAgeGroup.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Therapy Preferences</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="therapy-delivery-mode">
                    Therapy Delivery Mode
                  </label>
                  <select
                    onChange={(e: any) => setTherapyMode(e.target.value)}
                    className="form-control"
                    name="therapy_delivery_modes"
                    id="therapy-delivery-mode"
                  >
                    {TherapyDeliveryMode.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="therapy-type">Therapy Type</label>
                  <select
                    onChange={(e: any) => setTherapytype(e.target.value)}
                    className="form-control"
                    name="therapy_type"
                    id="therapy-type"
                  >
                    {SuggestedTherapyType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="preferred_language">Preferred Language</label>
                  <MultiSelect
                    options={PreferedLanguage}
                    // className="form-control"
                    labelledBy="Select Languages"
                    value={language}
                    onChange={setLanguage}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>EHC Screening Result</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name1">
                    Suggested Expert Name 1
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name1"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    // value={}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name1",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name2">
                    Suggested Expert Name 2
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name2"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    required
                    // value={}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name2",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name3">
                    Suggested Expert Name 3
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name3"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    required
                    // value={}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name3",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggest_therapy_type">
                    Suggested Therapy Type
                  </label>
                  <select
                    onChange={handleChange}
                    className="form-control"
                    name="suggest_therapy_type"
                    required
                    id="suggest_therapy_type"
                  >
                    {SuggestedTherapyType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Notes</h4>
                </div>
                <div className="form-group col-md-12 mb-4 pl-0">
                  <textarea
                    onChange={handleChange}
                    className="form-control"
                    id="notes"
                    required
                    name="notes"
                  ></textarea>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>EHC Followup Notes</h4>
                </div>
                <div className="form-group col-md-12 mb-4 pl-0">
                  <textarea
                    onChange={handleChange}
                    className="form-control"
                    id="ehc_followup_notes"
                    required
                    name="ehc_followup_notes"
                  ></textarea>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Booking Information</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="booking_date">
                    {" "}
                    Booking Date (24H Format)
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    required
                    name="booking_date"
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="booking_time">
                    {" "}
                    Booking Time (24H Format)
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    required
                    name="booking_time"
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="booking_amount"> Booking Amount </label>
                  <input
                    onChange={handleBookingDetails}
                    type="text"
                    className="form-control"
                    id="booking_amount"
                    required
                    name="booking_amount"
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="subscription_amount">
                    Subscription Amount
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="text"
                    className="form-control"
                    id="subscription_amount"
                    required
                    name="subscription_amount"
                    defaultValue=""
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="booking_expert">Select Booking Expert</label>
                  <select
                    onChange={handleBookingDetails}
                    className="form-control"
                    name="booking_expert"
                    required
                    id="booking_expert"
                  >
                    {SuggestedExperts.map((el: any) => (
                      <option value={el.value}>{el.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="sendEhcNotification"
                  name="sendEhcNotification"
                  value={isNotificationSend}
                  onChange={(e) => setIsNotificationSend(e.target.checked)}
                />
                <label
                  className="form-check-label"
                  htmlFor="sendEhcNotification"
                >
                  Send EHC Notification
                </label>
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
